/*
 * @Author: Teemo Ding
 * @Date: 2021-07-14 10:15:12
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-07-14 10:16:07
 * @FilePath: /unifyxp-v2-store-portal/src/request/salesChannel/setting/order.ts
 */
import { post, get } from 'src/tools/server';

export const request_orderData = (salesChannelUuid: string) => {
  return get<any>(`/portal/salesChannel/${salesChannelUuid}/setting/order`, {});
};

export const save_orderData = (salesChannelUuid: string, data) => {
  return post<any>(
    `/portal/salesChannel/${salesChannelUuid}/setting/order`,
    data,
    {},
  );
};
